import {
  ADMIN_PROPERTY_STATUSES,
  normalizePropertyStatus,
} from "./propertyStatus.js";

const STATUS_PRIORITY = ADMIN_PROPERTY_STATUSES.reduce((priorities, status, index) => {
  priorities[status] = index;
  return priorities;
}, {});

/**
 * Sort properties by the admin status priority.
 * Ranked statuses are ordered first; everything else is appended afterward.
 * Relative order is preserved within the same priority bucket.
 * @param {Array} properties
 * @returns {Array}
 */
export const sortPropertiesByStatusPriority = (properties) => {
  if (!Array.isArray(properties)) return properties;

  return properties
    .map((property, index) => ({
      property,
      index,
      priority:
        STATUS_PRIORITY[normalizePropertyStatus(property?.status)] ??
        Number.MAX_SAFE_INTEGER,
    }))
    .sort((left, right) => {
      if (left.priority !== right.priority) {
        return left.priority - right.priority;
      }
      return left.index - right.index;
    })
    .map(({ property }) => property);
};
